import Carousel from '@molecules/Carousel/Carousel';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export const StyledSlotDateCarousel = styled(Carousel)<{ $isTouch: boolean }>`
  padding: 0 ${rem(14)} ${rem(16)} ${rem(14)};
  ${({ $isTouch: isTouch }) =>
    isTouch &&
    css`
      padding: 0 ${rem(20)} ${rem(16)} ${rem(20)};
    `}
`;
